import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
    return (
        <div className="min-h-screen bg-[var(--color-bg)] text-text-main flex items-center justify-center px-6">
            <div
                data-testid="not-found-card"
                className="w-full max-w-md text-center"
            >
                <p className="text-[11px] uppercase tracking-widest text-text-secondary">
                    404
                </p>
                <h1
                    data-testid="not-found-title"
                    className="mt-3 text-3xl font-semibold tracking-tight gradient-text"
                >
                    Page not found
                </h1>
                <p className="mt-3 text-sm text-text-secondary">
                    The page you're looking for doesn't exist or has been moved.
                </p>
                <Link
                    to="/"
                    data-testid="not-found-home-link"
                    className="mt-8 inline-flex items-center gap-2 rounded-full border border-[var(--color-border)] px-5 py-2.5 text-sm text-text-secondary hover:text-text-main hover:border-[var(--color-primary)]/50 transition-colors"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Back to landing
                </Link>
            </div>
        </div>
    );
}
